import hasFeature from 'modules/core/lib/hasFeature'

import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'

export const hasPolicyTemporality = () =>
  hasFeature('timeoff_policy_timeline') && timeoffPolicies.length >= 2
